import {
  FlexCol,
  FlexRow,
  DisplayTokenAmount,
  SVGWrapper,
  Typography,
  Card,
  DisplayMoney,
} from "@shared";
import { InfoTooltip } from "../../tooltip/InfoTooltip";
import { contractAddresses } from "../../../../meta";
import { useReserveAssetByAddress } from "../../../state/reserveholder/useReserveAssetByAddres";
import StEthIcon from "@assets/tokens/stEth.svg";
import { useGetPriceByAddress } from "../../../state/price-feed-aggregator/useGetPriceByAddress";

export const StEthCard = () => {
  const { data: stEth, ...stEthRest } = useReserveAssetByAddress(
    contractAddresses.stETH
  );
  const { displayData: stEthPrice } = useGetPriceByAddress(
    contractAddresses.stETH
  );

  return (
    <FlexCol className="h-[60px] py-2 px-[10px] justify-between ">
      {/* Display the value and tooltip icon */}
      <FlexRow className="w-full items-start justify-between">
        <DisplayTokenAmount
          {...stEthRest}
          {...stEth.balanceOf}
          symbol=""
          typography="body-medium-medium"
        />
        <InfoTooltip>
          {/* Tooltip content displaying detailed stETH information */}
          <FlexCol className="w-[300px] h-[208px] p-3 gap-3 ">
            <FlexRow className="gap-3 items-center">
              <SVGWrapper src={StEthIcon} width="16px" height="16px" />
              <Typography type="body-small-medium">stETH</Typography>
            </FlexRow>

            {/* Conversion details for stETH */}
            <Card hasBorder hasShadowInstead className="w-full">
              <FlexRow className="w-full gap-1 px-3 py-[10px] items-center justify-between">
                <DisplayTokenAmount
                  {...stEthRest}
                  {...stEth.balanceOf}
                  symbol=""
                  typography="body-medium-regular"
                />
                <Typography
                  type="body-medium-regular"
                  className="text-neutral-black-50"
                >
                  stETH
                </Typography>
              </FlexRow>
            </Card>
            <Card hasBorder hasShadowInstead className="w-full">
              <FlexRow className="w-full gap-1 px-3 py-[10px] items-center justify-between">
                <DisplayMoney
                  {...stEthRest}
                  {...stEth.dollarAmount}
                  symbol=""
                  typography="body-medium-regular"
                />

                <Typography
                  className="text-neutral-black-50"
                  type="body-medium-regular"
                >
                  USD
                </Typography>
              </FlexRow>
            </Card>

            {/* Conversion rate display */}
            <Typography
              type="caption-regular"
              className="text-neutral-black-50"
            >
              The price of converting 1 Lido Staked Ether (stETH) to USD is{" "}
              {stEthPrice?.value} today.
            </Typography>
          </FlexCol>
        </InfoTooltip>
      </FlexRow>

      {/* Asset identifier row */}
      <FlexRow className="w-full gap-1 items-center">
        <SVGWrapper src={StEthIcon} width="16px" height="16px" />
        <Typography type="caption-medium" className="text-neutral-black-60">
          stETH
        </Typography>
      </FlexRow>
    </FlexCol>
  );
};
